module.exports = __webpack_public_path__ + "static/people_pop8-28cabb85528d3fc52bfdc747f98116a2.png";